"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useOrder = void 0;
var react_1 = __importDefault(require("react"));
var generate_order_1 = require("../lib/generate-order");
function useOrder(order, tasks) {
    return react_1["default"].useMemo(function () { return (0, generate_order_1.generateOrder)(order, tasks); }, [order, tasks]);
}
exports.useOrder = useOrder;
